import { useState } from 'react'
import SiginInPopup from "Components/Popup/SiginInPopup/SiginInPopup";
import CustomModel from "Utills/Model/CustomModel";
import { Button } from "@material-ui/core"
import {Link} from "react-router-dom";
import { Helmet } from 'react-helmet';

//=================== THIS COMPONENT WILL USE AS a message to user when not logged in =================================
const NotLoggedIn = () => {
    const [showPopup, setShowPopup] = useState(false);
    return (
        <>
         <Helmet>
        <title>Cyan | Login</title>
      </Helmet>
            <CustomModel openPopup={showPopup} setOpenPopup={setShowPopup} >
                <SiginInPopup
                    closeModel={setShowPopup}
                />
            </CustomModel>
            <div className="container header-spacer my-5 py-5">
                <div className="row">
                    <div className="col-12 mx-auto text-center">
                        <p>You are not logged in to your account</p>
                        <br />
                        <div className="d-flex justify-content-center align-items-center flex-wrap w-100">
                        <Button component={Link} className="mx-4"to="/signup" variant="contained" color="primary">Sign up</Button>
                        <Button onClick={() => setShowPopup(true)} variant="outlined" color="primary">Login</Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NotLoggedIn;
